import React from 'react';

import IconButton from 'ha/ui/next/IconButton';
import { ArrowForwardIcon, ArrowBackIcon, CloseIcon } from 'ha/ui/next/Icons';
import { NormalizedListing } from 'ha/modules/Algolia/Types';
import Grid from 'ha/ui/next/Grid';

import { DataTestAttrs } from './constants';

interface Props {
  rooms: NormalizedListing[];
  onClose: () => void;
  currentRoomIndex: number;
  onPreviousClick: React.MouseEventHandler<HTMLElement>;
  onNextClick: React.MouseEventHandler<HTMLElement>;
}

const SearchMapPreviewControls: React.FC<Props> = ({
  rooms,
  onClose,
  currentRoomIndex,
  onPreviousClick,
  onNextClick,
}) => (
  <Grid container alignItems="center" alignContent="space-between">
    <Grid item xs={10}>
      <IconButton
        data-test-locator={DataTestAttrs.PREV}
        disabled={currentRoomIndex === 0}
        onClick={onPreviousClick}
      >
        <ArrowBackIcon />
      </IconButton>
      {currentRoomIndex + 1} of {rooms.length}
      <IconButton
        data-test-locator={DataTestAttrs.NEXT}
        disabled={currentRoomIndex === rooms.length - 1}
        onClick={onNextClick}
      >
        <ArrowForwardIcon />
      </IconButton>
    </Grid>
    <Grid item xs={2}>
      <IconButton data-test-locator={DataTestAttrs.CLOSE} onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </Grid>
  </Grid>
);

SearchMapPreviewControls.displayName = 'SearchMapPreviewControls';

export default SearchMapPreviewControls;
